import { useLocation, useParams } from 'react-router-dom';
import { useChannelPost } from '@/hooks/api/useChannelPost';
import * as _m from '@/models';
import { Dispatch, RefObject, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import { useCustomEvent } from '@/hooks/gtm/useCustomEvent';
import { useMoviePlays } from '@/hooks/api/useMoviePlays';
import { ReactHlsPlayer } from '@/components/common/ReactHlsPlayer';

export const MovieEmbed = () => {
  const { cid, id } = useParams<{ cid: string; id: string }>();
  const { data: channel_post, isError: isChannelPostError } = useChannelPost(cid || '', id ? Number(id) : 0);
  const [playing, setPlaying] = useState<boolean>(false);
  const hlsPlayerRef = useRef<HTMLVideoElement>(null);
  if (!channel_post) return <></>;

  return (
    <div className={`embedded-movie-wrapper`}>
      <MoviePlayer channel_post={channel_post} setPlaying={setPlaying} hlsPlayerRef={hlsPlayerRef} />
      {!playing && (
        <div
          className="cover active"
          onClick={() => {
            hlsPlayerRef.current?.play();
          }}
        ></div>
      )}
    </div>
  );
};

const MoviePlayer = ({
  channel_post,
  setPlaying,
  hlsPlayerRef,
  ...props
}: {
  channel_post: _m.ChannelPost;
  setPlaying: Dispatch<SetStateAction<boolean>>;
  hlsPlayerRef: RefObject<HTMLVideoElement>;
}) => {
  const location = useLocation();
  const [played, setPlayed] = useState(false);
  const { moviePlayEvent } = useCustomEvent();
  const { mutation } = useMoviePlays();

  const onPlayClicked = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    setPlayed(true);
    setPlaying(true);
  };

  const onPauseClicked = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    setPlaying(false);
  };

  useEffect(() => {
    if (played) {
      moviePlayEvent(location.pathname);
      mutation.mutate({ cid: channel_post.channel_outline.cid, id: channel_post.id });
    }
  }, [played]);

  const player = (
    <ReactHlsPlayer
      playerRef={hlsPlayerRef}
      src={channel_post.channel_post_movie.movie_url}
      controls={true}
      controlsList={'nodownload'}
      onContextMenu={(e) => e.preventDefault()}
      type={'movie'}
      hlsConfig={{
        xhrSetup: (xhr: any) => {
          xhr.withCredentials = true;
        },
      }}
      poster={channel_post.cover_image_url}
      onPlay={(e) => onPlayClicked(e)}
      onPause={(e) => onPauseClicked(e)}
      {...props}
    />
  );

  return useMemo(() => player, []);
};
